// ---------------------------------------------------------------------------
// cogo-ns-v1-shacl-rules.ts — AUTO-GENERATED. DO NOT EDIT.
//
// Generated by `pnpm --filter @cogo/kg-repository compile-shacl`
// from `cogo-web/packages/cogo-kg-browser/fixtures/cogo-ns-v1.ttl`.
//
// 463 rules total (agentPromptGuide-datatype: 1, allowedChildren-class: 1, appId-datatype: 3, approvedAt-datatype: 1, archetype-datatype: 2, archetype-in: 2, atomDefaultsRef-class: 1, authModes-datatype: 1, authModes-in: 1, availableSizes-datatype: 1, availableVariants-datatype: 1, binding-class: 1, blockJson-datatype: 1, blocksCount-datatype: 1, blockType-class: 1, candidateAction-datatype: 1, candidateAction-in: 1, canonicalField-class: 1, canonicalSource-datatype: 1, category-datatype: 5, category-in: 5, classNameAllowed-datatype: 1, classNameForbidden-datatype: 1, code-datatype: 1, code-pattern: 1, colorRoles-datatype: 1, colors-datatype: 1, commonAction-class: 1, commonEvent-class: 1, components-datatype: 1, confidence-datatype: 1, configSchema-class: 1, dateFormats-datatype: 1, defaultComponent-class: 1, defaultLocale-datatype: 1, defaultLocale-pattern: 1, defaultTimeout-datatype: 1, deprecated-datatype: 1, description-datatype: 8, designSystemId-datatype: 1, designSystemId-pattern: 1, domain-datatype: 1, domain-in: 1, domainSemantics-datatype: 1, dosDonts-datatype: 1, dsCompatibility-class: 1, effects-class: 1, emitsEvents-class: 2, emittedByAction-class: 1, emittedByComponent-class: 1, emittedByDatasource-class: 1, exampleTags-datatype: 1, extends-class: 1, extendsSystem-class: 1, fieldType-datatype: 1, fieldType-in: 1, flutter-datatype: 1, frequency-datatype: 1, hasSection-class: 1, hslDark-datatype: 1, hslLight-datatype: 1, i18n-class: 1, i18nRef-class: 1, implementation-datatype: 1, implementation-pattern: 1, industry-datatype: 1, interaction-datatype: 1, isShadcnPreset-datatype: 1, judgeModel-datatype: 1, keyword-datatype: 1, level-datatype: 1, level-in: 1, lifecycleRules-datatype: 1, lifecycleRules-in: 1, lineHeight-datatype: 1, localeOverrides-datatype: 1, makesNetworkCalls-datatype: 1, max-count: 153, message-datatype: 1, metadataDescription-datatype: 1, metadataName-datatype: 1, min-count: 75, minFontScale-datatype: 1, minFontScale-in: 1, name-datatype: 14, name-pattern: 12, narrative-class: 1, narrativeRef-class: 1, narrativeSummary-datatype: 1, navigates-datatype: 1, numberFormats-datatype: 1, observedAt-datatype: 1, obsSeverity-datatype: 1, obsSeverity-in: 1, operationTypes-datatype: 1, operationTypes-in: 1, palette-datatype: 1, paramsSchema-class: 1, parentSlot-class: 1, pattern-datatype: 2, patternId-datatype: 1, patternId-pattern: 1, patternRef-class: 1, payloadSchema-class: 1, phase-datatype: 1, phase-in: 2, platform-datatype: 1, platform-in: 1, platforms-class: 2, presetClassMap-datatype: 1, promptKind-datatype: 1, promptKind-in: 1, prop-datatype: 1, proposedRule-class: 1, qualityGrade-datatype: 1, radius-datatype: 1, reactNative-datatype: 1, read-datatype: 1, recipe-class: 1, referoTitle-datatype: 1, referoUrl-datatype: 1, referoUuid-datatype: 1, referoUuid-pattern: 1, relatedActions-class: 1, rendererHandles-datatype: 1, replacedBy-class: 1, required-datatype: 1, requiredBindings-datatype: 1, requiredChildren-datatype: 1, requiredEvents-datatype: 1, requiredTokens-datatype: 1, requiresAuth-datatype: 1, requiresCapability-class: 2, responsiveBehavior-datatype: 1, resultShape-class: 1, reversible-datatype: 1, route-datatype: 2, score-datatype: 1, semanticRoot-class: 1, semanticType-class: 1, severity-datatype: 2, severity-in: 2, slot-datatype: 1, slotsOptional-datatype: 1, slotsRequired-datatype: 1, spacing-datatype: 1, sparqlAsk-datatype: 1, stateMatrix-datatype: 1, statePath-datatype: 1, statePath-pattern: 1, styleTheme-datatype: 1, styleTheme-in: 1, supportedLocales-datatype: 1, supportedLocales-pattern: 1, supportsEvents-class: 1, symbol-class: 1, tailwindClass-datatype: 1, template-datatype: 1, template-pattern: 1, themeGradient-datatype: 1, themeId-datatype: 1, themeVersion-datatype: 1, thumbnail-datatype: 1, tier-datatype: 1, tier-in: 1, timestamp-datatype: 1, tokens-class: 1, tokensRef-class: 1, tokenType-datatype: 1, tokenType-in: 1, tolerance-datatype: 1, transportProtocol-datatype: 1, transportProtocol-in: 1, typeScale-datatype: 1, typography-datatype: 1, uiCategory-datatype: 1, uiCategory-in: 1, uiMayContainChildren-datatype: 1, unit-datatype: 1, usesAction-class: 1, usesDataSymbol-class: 1, value-datatype: 1, visualTheme-datatype: 1, web-datatype: 1, wireCode-datatype: 1, write-datatype: 1).
//
// Consumers: `cogo-studio/src/features/validation/shacl-rules.ts`,
// `cogo-starter/src/validation/shacl-rules.ts`,
// `cogo-commerce/src/validation/shacl-rules.ts`. Each app imports
// `STRUCTURAL_RULES` below and wraps it with a `MapBackedRuleRegistry`
// at `KgProvider` construction.
// ---------------------------------------------------------------------------

import type { ShaclQueryRule } from "@cogo/kg-browser"

export const STRUCTURAL_RULES: readonly ShaclQueryRule[] = [
  {
    "shape": "cogo:ActionShape#category-min-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Action .\n  FILTER NOT EXISTS { ?focus cogo:category ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action is missing cogo:category (minCount=1)"
  },
  {
    "shape": "cogo:ActionShape#category-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:category ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:category"
  },
  {
    "shape": "cogo:ActionShape#category-datatype",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:category ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.category must be xsd:string"
  },
  {
    "shape": "cogo:ActionShape#category-in",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:category ?v .\n  FILTER(STR(?v) NOT IN (\"state\", \"data\", \"navigation\", \"ui\", \"flow\", \"flow-control\", \"device\", \"crypto\", \"auth\", \"payment\", \"system\", \"analytics\", \"commerce\", \"i18n\", \"realtime\", \"media\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.category must be one of [state, data, navigation, ui, flow, flow-control, device, crypto, auth, payment, system, analytics, commerce, i18n, realtime, media]"
  },
  {
    "shape": "cogo:ActionShape#deprecated-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:deprecated ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:deprecated"
  },
  {
    "shape": "cogo:ActionShape#deprecated-datatype",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:deprecated ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.deprecated must be xsd:boolean"
  },
  {
    "shape": "cogo:ActionShape#description-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:description"
  },
  {
    "shape": "cogo:ActionShape#description-datatype",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.description must be xsd:string"
  },
  {
    "shape": "cogo:ActionShape#effects-min-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Action .\n  FILTER NOT EXISTS { ?focus cogo:effects ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action is missing cogo:effects (minCount=1)"
  },
  {
    "shape": "cogo:ActionShape#effects-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:effects ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:effects"
  },
  {
    "shape": "cogo:ActionShape#effects-class",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:effects ?v .\n  FILTER NOT EXISTS { ?v a cogo:ActionEffects }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.effects must be a cogo:ActionEffects"
  },
  {
    "shape": "cogo:ActionShape#emitsEvents-class",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:emitsEvents ?v .\n  FILTER NOT EXISTS { ?v a cogo:Event }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.emitsEvents must be a cogo:Event"
  },
  {
    "shape": "cogo:ActionShape#implementation-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:implementation ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:implementation"
  },
  {
    "shape": "cogo:ActionShape#implementation-datatype",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:implementation ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.implementation must be xsd:string"
  },
  {
    "shape": "cogo:ActionShape#implementation-pattern",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:implementation ?v .\n  FILTER(!REGEX(STR(?v), \"^[^#\\\\s]+#[A-Za-z_][A-Za-z0-9_]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.implementation must match /^[^#\\s]+#[A-Za-z_][A-Za-z0-9_]*$/"
  },
  {
    "shape": "cogo:ActionShape#level-min-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Action .\n  FILTER NOT EXISTS { ?focus cogo:level ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action is missing cogo:level (minCount=1)"
  },
  {
    "shape": "cogo:ActionShape#level-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:level ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:level"
  },
  {
    "shape": "cogo:ActionShape#level-datatype",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:level ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.level must be xsd:string"
  },
  {
    "shape": "cogo:ActionShape#level-in",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:level ?v .\n  FILTER(STR(?v) NOT IN (\"L1\", \"L2\", \"L3\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.level must be one of [L1, L2, L3]"
  },
  {
    "shape": "cogo:ActionShape#name-min-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Action .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:ActionShape#name-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:name"
  },
  {
    "shape": "cogo:ActionShape#name-datatype",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.name must be xsd:string"
  },
  {
    "shape": "cogo:ActionShape#name-pattern",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-zA-Z0-9]*(_[a-z][a-zA-Z0-9]*)*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.name must match /^[a-z][a-zA-Z0-9]*(_[a-z][a-zA-Z0-9]*)*$/"
  },
  {
    "shape": "cogo:ActionShape#paramsSchema-min-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Action .\n  FILTER NOT EXISTS { ?focus cogo:paramsSchema ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action is missing cogo:paramsSchema (minCount=1)"
  },
  {
    "shape": "cogo:ActionShape#paramsSchema-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:paramsSchema ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:paramsSchema"
  },
  {
    "shape": "cogo:ActionShape#paramsSchema-class",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:paramsSchema ?v .\n  FILTER NOT EXISTS { ?v a cogo:JsonSchemaRef }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.paramsSchema must be a cogo:JsonSchemaRef"
  },
  {
    "shape": "cogo:ActionShape#platforms-min-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Action .\n  FILTER NOT EXISTS { ?focus cogo:platforms ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action is missing cogo:platforms (minCount=1)"
  },
  {
    "shape": "cogo:ActionShape#platforms-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:platforms ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:platforms"
  },
  {
    "shape": "cogo:ActionShape#platforms-class",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:platforms ?v .\n  FILTER NOT EXISTS { ?v a cogo:PlatformSupport }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.platforms must be a cogo:PlatformSupport"
  },
  {
    "shape": "cogo:ActionShape#replacedBy-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:replacedBy ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:replacedBy"
  },
  {
    "shape": "cogo:ActionShape#replacedBy-class",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:replacedBy ?v .\n  FILTER NOT EXISTS { ?v a cogo:Action }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.replacedBy must be a cogo:Action"
  },
  {
    "shape": "cogo:ActionShape#requiresCapability-class",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:requiresCapability ?v .\n  FILTER NOT EXISTS { ?v a cogo:Capability }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.requiresCapability must be a cogo:Capability"
  },
  {
    "shape": "cogo:ActionShape#resultShape-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:resultShape ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:resultShape"
  },
  {
    "shape": "cogo:ActionShape#resultShape-class",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:resultShape ?v .\n  FILTER NOT EXISTS { ?v a cogo:JsonSchemaRef }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.resultShape must be a cogo:JsonSchemaRef"
  },
  {
    "shape": "cogo:ActionShape#tier-min-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Action .\n  FILTER NOT EXISTS { ?focus cogo:tier ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action is missing cogo:tier (minCount=1)"
  },
  {
    "shape": "cogo:ActionShape#tier-max-count",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Action ; cogo:tier ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action has more than 1 cogo:tier"
  },
  {
    "shape": "cogo:ActionShape#tier-datatype",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:tier ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.tier must be xsd:string"
  },
  {
    "shape": "cogo:ActionShape#tier-in",
    "focusClass": "Action",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Action ; cogo:tier ?v .\n  FILTER(STR(?v) NOT IN (\"core\", \"extended\", \"standard\", \"platform\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Action.tier must be one of [core, extended, standard, platform]"
  },
  {
    "shape": "cogo:ActionEffectsShape#makesNetworkCalls-max-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ActionEffects ; cogo:makesNetworkCalls ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects has more than 1 cogo:makesNetworkCalls"
  },
  {
    "shape": "cogo:ActionEffectsShape#makesNetworkCalls-datatype",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ActionEffects ; cogo:makesNetworkCalls ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects.makesNetworkCalls must be xsd:boolean"
  },
  {
    "shape": "cogo:ActionEffectsShape#navigates-max-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ActionEffects ; cogo:navigates ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects has more than 1 cogo:navigates"
  },
  {
    "shape": "cogo:ActionEffectsShape#navigates-datatype",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ActionEffects ; cogo:navigates ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects.navigates must be xsd:boolean"
  },
  {
    "shape": "cogo:ActionEffectsShape#read-min-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:ActionEffects .\n  FILTER NOT EXISTS { ?focus cogo:read ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects is missing cogo:read (minCount=1)"
  },
  {
    "shape": "cogo:ActionEffectsShape#read-max-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ActionEffects ; cogo:read ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects has more than 1 cogo:read"
  },
  {
    "shape": "cogo:ActionEffectsShape#read-datatype",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ActionEffects ; cogo:read ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects.read must be xsd:boolean"
  },
  {
    "shape": "cogo:ActionEffectsShape#requiresAuth-min-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:ActionEffects .\n  FILTER NOT EXISTS { ?focus cogo:requiresAuth ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects is missing cogo:requiresAuth (minCount=1)"
  },
  {
    "shape": "cogo:ActionEffectsShape#requiresAuth-max-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ActionEffects ; cogo:requiresAuth ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects has more than 1 cogo:requiresAuth"
  },
  {
    "shape": "cogo:ActionEffectsShape#requiresAuth-datatype",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ActionEffects ; cogo:requiresAuth ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects.requiresAuth must be xsd:boolean"
  },
  {
    "shape": "cogo:ActionEffectsShape#requiresCapability-class",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ActionEffects ; cogo:requiresCapability ?v .\n  FILTER NOT EXISTS { ?v a cogo:Capability }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects.requiresCapability must be a cogo:Capability"
  },
  {
    "shape": "cogo:ActionEffectsShape#reversible-min-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:ActionEffects .\n  FILTER NOT EXISTS { ?focus cogo:reversible ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects is missing cogo:reversible (minCount=1)"
  },
  {
    "shape": "cogo:ActionEffectsShape#reversible-max-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ActionEffects ; cogo:reversible ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects has more than 1 cogo:reversible"
  },
  {
    "shape": "cogo:ActionEffectsShape#reversible-datatype",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ActionEffects ; cogo:reversible ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects.reversible must be xsd:boolean"
  },
  {
    "shape": "cogo:ActionEffectsShape#write-min-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:ActionEffects .\n  FILTER NOT EXISTS { ?focus cogo:write ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects is missing cogo:write (minCount=1)"
  },
  {
    "shape": "cogo:ActionEffectsShape#write-max-count",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ActionEffects ; cogo:write ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects has more than 1 cogo:write"
  },
  {
    "shape": "cogo:ActionEffectsShape#write-datatype",
    "focusClass": "ActionEffects",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ActionEffects ; cogo:write ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ActionEffects.write must be xsd:boolean"
  },
  {
    "shape": "cogo:BlockShape#archetype-min-count",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Block .\n  FILTER NOT EXISTS { ?focus cogo:archetype ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block is missing cogo:archetype (minCount=1)"
  },
  {
    "shape": "cogo:BlockShape#archetype-max-count",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Block ; cogo:archetype ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block has more than 1 cogo:archetype"
  },
  {
    "shape": "cogo:BlockShape#archetype-datatype",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Block ; cogo:archetype ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block.archetype must be xsd:string"
  },
  {
    "shape": "cogo:BlockShape#archetype-in",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Block ; cogo:archetype ?v .\n  FILTER(STR(?v) NOT IN (\"auth-login\", \"auth-signup\", \"list-view\", \"detail-view\", \"form-submit\", \"dashboard\", \"settings\", \"checkout\", \"onboarding\", \"generic\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block.archetype must be one of [auth-login, auth-signup, list-view, detail-view, form-submit, dashboard, settings, checkout, onboarding, generic]"
  },
  {
    "shape": "cogo:BlockShape#name-min-count",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Block .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:BlockShape#name-max-count",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Block ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block has more than 1 cogo:name"
  },
  {
    "shape": "cogo:BlockShape#name-datatype",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Block ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block.name must be xsd:string"
  },
  {
    "shape": "cogo:BlockShape#name-pattern",
    "focusClass": "Block",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Block ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Block.name must match /^[a-z][a-z0-9-]*$/"
  },
  {
    "shape": "cogo:CapabilityShape#description-max-count",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Capability ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability has more than 1 cogo:description"
  },
  {
    "shape": "cogo:CapabilityShape#description-datatype",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Capability ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability.description must be xsd:string"
  },
  {
    "shape": "cogo:CapabilityShape#name-min-count",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Capability .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:CapabilityShape#name-max-count",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Capability ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability has more than 1 cogo:name"
  },
  {
    "shape": "cogo:CapabilityShape#name-datatype",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Capability ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability.name must be xsd:string"
  },
  {
    "shape": "cogo:CapabilityShape#name-pattern",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Capability ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9]*(\\\\.[a-z][a-z0-9]*)+$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability.name must match /^[a-z][a-z0-9]*(\\.[a-z][a-z0-9]*)+$/"
  },
  {
    "shape": "cogo:CapabilityShape#platform-min-count",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Capability .\n  FILTER NOT EXISTS { ?focus cogo:platform ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability is missing cogo:platform (minCount=1)"
  },
  {
    "shape": "cogo:CapabilityShape#platform-datatype",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Capability ; cogo:platform ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability.platform must be xsd:string"
  },
  {
    "shape": "cogo:CapabilityShape#platform-in",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Capability ; cogo:platform ?v .\n  FILTER(STR(?v) NOT IN (\"web\", \"ios\", \"android\", \"desktop\", \"cli\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability.platform must be one of [web, ios, android, desktop, cli]"
  },
  {
    "shape": "cogo:CapabilityShape#promptKind-max-count",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Capability ; cogo:promptKind ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability has more than 1 cogo:promptKind"
  },
  {
    "shape": "cogo:CapabilityShape#promptKind-datatype",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Capability ; cogo:promptKind ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability.promptKind must be xsd:string"
  },
  {
    "shape": "cogo:CapabilityShape#promptKind-in",
    "focusClass": "Capability",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Capability ; cogo:promptKind ?v .\n  FILTER(STR(?v) NOT IN (\"permission-dialog\", \"settings-deeplink\", \"oauth-redirect\", \"system-prompt\", \"none\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Capability.promptKind must be one of [permission-dialog, settings-deeplink, oauth-redirect, system-prompt, none]"
  },
  {
    "shape": "cogo:DatasourceTypeShape#authModes-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:authModes ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.authModes must be xsd:string"
  },
  {
    "shape": "cogo:DatasourceTypeShape#authModes-in",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:authModes ?v .\n  FILTER(STR(?v) NOT IN (\"anonymous\", \"password\", \"oauth\", \"key\", \"jwt\", \"session\", \"service-role\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.authModes must be one of [anonymous, password, oauth, key, jwt, session, service-role]"
  },
  {
    "shape": "cogo:DatasourceTypeShape#category-min-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DatasourceType .\n  FILTER NOT EXISTS { ?focus cogo:category ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType is missing cogo:category (minCount=1)"
  },
  {
    "shape": "cogo:DatasourceTypeShape#category-max-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DatasourceType ; cogo:category ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType has more than 1 cogo:category"
  },
  {
    "shape": "cogo:DatasourceTypeShape#category-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:category ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.category must be xsd:string"
  },
  {
    "shape": "cogo:DatasourceTypeShape#category-in",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:category ?v .\n  FILTER(STR(?v) NOT IN (\"remote\", \"local\", \"realtime\", \"composite\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.category must be one of [remote, local, realtime, composite]"
  },
  {
    "shape": "cogo:DatasourceTypeShape#configSchema-min-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DatasourceType .\n  FILTER NOT EXISTS { ?focus cogo:configSchema ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType is missing cogo:configSchema (minCount=1)"
  },
  {
    "shape": "cogo:DatasourceTypeShape#configSchema-max-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DatasourceType ; cogo:configSchema ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType has more than 1 cogo:configSchema"
  },
  {
    "shape": "cogo:DatasourceTypeShape#configSchema-class",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:configSchema ?v .\n  FILTER NOT EXISTS { ?v a cogo:JsonSchemaRef }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.configSchema must be a cogo:JsonSchemaRef"
  },
  {
    "shape": "cogo:DatasourceTypeShape#defaultTimeout-max-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DatasourceType ; cogo:defaultTimeout ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType has more than 1 cogo:defaultTimeout"
  },
  {
    "shape": "cogo:DatasourceTypeShape#defaultTimeout-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:defaultTimeout ?v .\n  FILTER(DATATYPE(?v) != xsd:duration)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.defaultTimeout must be xsd:duration"
  },
  {
    "shape": "cogo:DatasourceTypeShape#emitsEvents-class",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:emitsEvents ?v .\n  FILTER NOT EXISTS { ?v a cogo:Event }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.emitsEvents must be a cogo:Event"
  },
  {
    "shape": "cogo:DatasourceTypeShape#lifecycleRules-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:lifecycleRules ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.lifecycleRules must be xsd:string"
  },
  {
    "shape": "cogo:DatasourceTypeShape#lifecycleRules-in",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:lifecycleRules ?v .\n  FILTER(STR(?v) NOT IN (\"must-close-on-unmount\", \"reconnect-backoff-required\", \"idempotent-writes\", \"retries-not-safe\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.lifecycleRules must be one of [must-close-on-unmount, reconnect-backoff-required, idempotent-writes, retries-not-safe]"
  },
  {
    "shape": "cogo:DatasourceTypeShape#name-min-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DatasourceType .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:DatasourceTypeShape#name-max-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DatasourceType ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType has more than 1 cogo:name"
  },
  {
    "shape": "cogo:DatasourceTypeShape#name-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.name must be xsd:string"
  },
  {
    "shape": "cogo:DatasourceTypeShape#name-pattern",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9_]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.name must match /^[a-z][a-z0-9_]*$/"
  },
  {
    "shape": "cogo:DatasourceTypeShape#operationTypes-min-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DatasourceType .\n  FILTER NOT EXISTS { ?focus cogo:operationTypes ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType is missing cogo:operationTypes (minCount=1)"
  },
  {
    "shape": "cogo:DatasourceTypeShape#operationTypes-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:operationTypes ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.operationTypes must be xsd:string"
  },
  {
    "shape": "cogo:DatasourceTypeShape#operationTypes-in",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:operationTypes ?v .\n  FILTER(STR(?v) NOT IN (\"read\", \"write\", \"subscribe\", \"unsubscribe\", \"invoke\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.operationTypes must be one of [read, write, subscribe, unsubscribe, invoke]"
  },
  {
    "shape": "cogo:DatasourceTypeShape#platforms-min-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DatasourceType .\n  FILTER NOT EXISTS { ?focus cogo:platforms ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType is missing cogo:platforms (minCount=1)"
  },
  {
    "shape": "cogo:DatasourceTypeShape#platforms-max-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DatasourceType ; cogo:platforms ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType has more than 1 cogo:platforms"
  },
  {
    "shape": "cogo:DatasourceTypeShape#platforms-class",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:platforms ?v .\n  FILTER NOT EXISTS { ?v a cogo:PlatformSupport }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.platforms must be a cogo:PlatformSupport"
  },
  {
    "shape": "cogo:DatasourceTypeShape#transportProtocol-min-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DatasourceType .\n  FILTER NOT EXISTS { ?focus cogo:transportProtocol ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType is missing cogo:transportProtocol (minCount=1)"
  },
  {
    "shape": "cogo:DatasourceTypeShape#transportProtocol-max-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DatasourceType ; cogo:transportProtocol ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType has more than 1 cogo:transportProtocol"
  },
  {
    "shape": "cogo:DatasourceTypeShape#transportProtocol-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:transportProtocol ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.transportProtocol must be xsd:string"
  },
  {
    "shape": "cogo:DatasourceTypeShape#transportProtocol-in",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:transportProtocol ?v .\n  FILTER(STR(?v) NOT IN (\"http\", \"https\", \"websocket\", \"sse\", \"tcp\", \"udp\", \"mqtt\", \"in-process\", \"local\", \"ftp\", \"grpc\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.transportProtocol must be one of [http, https, websocket, sse, tcp, udp, mqtt, in-process, local, ftp, grpc]"
  },
  {
    "shape": "cogo:DatasourceTypeShape#wireCode-max-count",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DatasourceType ; cogo:wireCode ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType has more than 1 cogo:wireCode"
  },
  {
    "shape": "cogo:DatasourceTypeShape#wireCode-datatype",
    "focusClass": "DatasourceType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DatasourceType ; cogo:wireCode ?v .\n  FILTER(DATATYPE(?v) != xsd:integer)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DatasourceType.wireCode must be xsd:integer"
  },
  {
    "shape": "cogo:DataSymbolShape#binding-class",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:binding ?v .\n  FILTER NOT EXISTS { ?v a cogo:SymbolBinding }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.binding must be a cogo:SymbolBinding"
  },
  {
    "shape": "cogo:DataSymbolShape#canonicalField-min-count",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DataSymbol .\n  FILTER NOT EXISTS { ?focus cogo:canonicalField ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol is missing cogo:canonicalField (minCount=1)"
  },
  {
    "shape": "cogo:DataSymbolShape#canonicalField-class",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:canonicalField ?v .\n  FILTER NOT EXISTS { ?v a cogo:FieldDefinition }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.canonicalField must be a cogo:FieldDefinition"
  },
  {
    "shape": "cogo:DataSymbolShape#commonAction-class",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:commonAction ?v .\n  FILTER NOT EXISTS { ?v a cogo:Action }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.commonAction must be a cogo:Action"
  },
  {
    "shape": "cogo:DataSymbolShape#commonEvent-class",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:commonEvent ?v .\n  FILTER NOT EXISTS { ?v a cogo:Event }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.commonEvent must be a cogo:Event"
  },
  {
    "shape": "cogo:DataSymbolShape#defaultComponent-class",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:defaultComponent ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.defaultComponent must be a cogo:SemanticType"
  },
  {
    "shape": "cogo:DataSymbolShape#description-max-count",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DataSymbol ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol has more than 1 cogo:description"
  },
  {
    "shape": "cogo:DataSymbolShape#description-datatype",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.description must be xsd:string"
  },
  {
    "shape": "cogo:DataSymbolShape#extends-max-count",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DataSymbol ; cogo:extends ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol has more than 1 cogo:extends"
  },
  {
    "shape": "cogo:DataSymbolShape#extends-class",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:extends ?v .\n  FILTER NOT EXISTS { ?v a cogo:DataSymbol }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.extends must be a cogo:DataSymbol"
  },
  {
    "shape": "cogo:DataSymbolShape#name-min-count",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DataSymbol .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:DataSymbolShape#name-max-count",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DataSymbol ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol has more than 1 cogo:name"
  },
  {
    "shape": "cogo:DataSymbolShape#name-datatype",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.name must be xsd:string"
  },
  {
    "shape": "cogo:DataSymbolShape#name-pattern",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DataSymbol ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[A-Z][A-Za-z0-9]*(\\\\.[A-Z][A-Za-z0-9]*)*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol.name must match /^[A-Z][A-Za-z0-9]*(\\.[A-Z][A-Za-z0-9]*)*$/"
  },
  {
    "shape": "cogo:DataSymbolShape#schemaOrgType-max-count",
    "focusClass": "DataSymbol",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DataSymbol ; cogo:schemaOrgType ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DataSymbol has more than 1 cogo:schemaOrgType"
  },
  {
    "shape": "cogo:DesignSystemShape#extendsSystem-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:extendsSystem ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:extendsSystem"
  },
  {
    "shape": "cogo:DesignSystemShape#extendsSystem-class",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:extendsSystem ?v .\n  FILTER NOT EXISTS { ?v a cogo:DesignSystem }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.extendsSystem must be a cogo:DesignSystem"
  },
  {
    "shape": "cogo:DesignSystemShape#name-min-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:DesignSystem .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:DesignSystemShape#name-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:name"
  },
  {
    "shape": "cogo:DesignSystemShape#name-datatype",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.name must be xsd:string"
  },
  {
    "shape": "cogo:DesignSystemShape#name-pattern",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.name must match /^[a-z][a-z0-9-]*$/"
  },
  {
    "shape": "cogo:DesignSystemShape#palette-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:palette ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:palette"
  },
  {
    "shape": "cogo:DesignSystemShape#palette-datatype",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:palette ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.palette must be xsd:string"
  },
  {
    "shape": "cogo:DesignSystemShape#presetClassMap-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:presetClassMap ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:presetClassMap"
  },
  {
    "shape": "cogo:DesignSystemShape#presetClassMap-datatype",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:presetClassMap ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.presetClassMap must be xsd:string"
  },
  {
    "shape": "cogo:DesignSystemShape#radius-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:radius ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:radius"
  },
  {
    "shape": "cogo:DesignSystemShape#radius-datatype",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:radius ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.radius must be xsd:string"
  },
  {
    "shape": "cogo:DesignSystemShape#tolerance-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:tolerance ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:tolerance"
  },
  {
    "shape": "cogo:DesignSystemShape#tolerance-datatype",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:tolerance ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.tolerance must be xsd:string"
  },
  {
    "shape": "cogo:DesignSystemShape#typography-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:typography ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:typography"
  },
  {
    "shape": "cogo:DesignSystemShape#typography-datatype",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:typography ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.typography must be xsd:string"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#designSystemId-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:designSystemId ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:designSystemId"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#designSystemId-datatype",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:designSystemId ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.designSystemId must be xsd:string"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#designSystemId-pattern",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:designSystemId ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.designSystemId must match /^[a-z][a-z0-9-]*$/"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#i18n-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:i18n ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:i18n"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#i18n-class",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:i18n ?v .\n  FILTER NOT EXISTS { ?v a cogo:I18n }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.i18n must be a cogo:I18n"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#narrative-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:narrative ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:narrative"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#narrative-class",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:narrative ?v .\n  FILTER NOT EXISTS { ?v a cogo:Narrative }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.narrative must be a cogo:Narrative"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#tokens-max-count",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DesignSystem ; cogo:tokens ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem has more than 1 cogo:tokens"
  },
  {
    "shape": "cogo:DesignSystemExtensionsShape#tokens-class",
    "focusClass": "DesignSystem",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DesignSystem ; cogo:tokens ?v .\n  FILTER NOT EXISTS { ?v a cogo:Tokens }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DesignSystem.tokens must be a cogo:Tokens"
  },
  {
    "shape": "cogo:DsCompatibilityShape#minFontScale-max-count",
    "focusClass": "DsCompatibility",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:DsCompatibility ; cogo:minFontScale ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DsCompatibility has more than 1 cogo:minFontScale"
  },
  {
    "shape": "cogo:DsCompatibilityShape#minFontScale-datatype",
    "focusClass": "DsCompatibility",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DsCompatibility ; cogo:minFontScale ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DsCompatibility.minFontScale must be xsd:string"
  },
  {
    "shape": "cogo:DsCompatibilityShape#minFontScale-in",
    "focusClass": "DsCompatibility",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DsCompatibility ; cogo:minFontScale ?v .\n  FILTER(STR(?v) NOT IN (\"xs\", \"sm\", \"md\", \"lg\", \"xl\", \"2xl\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DsCompatibility.minFontScale must be one of [xs, sm, md, lg, xl, 2xl]"
  },
  {
    "shape": "cogo:DsCompatibilityShape#requiredTokens-datatype",
    "focusClass": "DsCompatibility",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:DsCompatibility ; cogo:requiredTokens ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "DsCompatibility.requiredTokens must be xsd:string"
  },
  {
    "shape": "cogo:EventShape#description-max-count",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Event ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event has more than 1 cogo:description"
  },
  {
    "shape": "cogo:EventShape#description-datatype",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.description must be xsd:string"
  },
  {
    "shape": "cogo:EventShape#domain-min-count",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Event .\n  FILTER NOT EXISTS { ?focus cogo:domain ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event is missing cogo:domain (minCount=1)"
  },
  {
    "shape": "cogo:EventShape#domain-max-count",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Event ; cogo:domain ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event has more than 1 cogo:domain"
  },
  {
    "shape": "cogo:EventShape#domain-datatype",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:domain ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.domain must be xsd:string"
  },
  {
    "shape": "cogo:EventShape#domain-in",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:domain ?v .\n  FILTER(STR(?v) NOT IN (\"pointer\", \"form\", \"keyboard\", \"table\", \"lifecycle\", \"ui\", \"navigation\", \"auth\", \"network\", \"stream\", \"camera\", \"location\", \"system\", \"chat\", \"payment\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.domain must be one of [pointer, form, keyboard, table, lifecycle, ui, navigation, auth, network, stream, camera, location, system, chat, payment]"
  },
  {
    "shape": "cogo:EventShape#emittedByAction-class",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:emittedByAction ?v .\n  FILTER NOT EXISTS { ?v a cogo:Action }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.emittedByAction must be a cogo:Action"
  },
  {
    "shape": "cogo:EventShape#emittedByComponent-class",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:emittedByComponent ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.emittedByComponent must be a cogo:SemanticType"
  },
  {
    "shape": "cogo:EventShape#emittedByDatasource-class",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:emittedByDatasource ?v .\n  FILTER NOT EXISTS { ?v a cogo:DatasourceType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.emittedByDatasource must be a cogo:DatasourceType"
  },
  {
    "shape": "cogo:EventShape#name-min-count",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Event .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:EventShape#name-max-count",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Event ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event has more than 1 cogo:name"
  },
  {
    "shape": "cogo:EventShape#name-datatype",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.name must be xsd:string"
  },
  {
    "shape": "cogo:EventShape#name-pattern",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-zA-Z0-9]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.name must match /^[a-z][a-zA-Z0-9]*$/"
  },
  {
    "shape": "cogo:EventShape#payloadSchema-max-count",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Event ; cogo:payloadSchema ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event has more than 1 cogo:payloadSchema"
  },
  {
    "shape": "cogo:EventShape#payloadSchema-class",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:payloadSchema ?v .\n  FILTER NOT EXISTS { ?v a cogo:JsonSchemaRef }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.payloadSchema must be a cogo:JsonSchemaRef"
  },
  {
    "shape": "cogo:EventShape#relatedActions-class",
    "focusClass": "Event",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Event ; cogo:relatedActions ?v .\n  FILTER NOT EXISTS { ?v a cogo:Action }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Event.relatedActions must be a cogo:Action"
  },
  {
    "shape": "cogo:ExampleShape#appId-min-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Example .\n  FILTER NOT EXISTS { ?focus cogo:appId ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example is missing cogo:appId (minCount=1)"
  },
  {
    "shape": "cogo:ExampleShape#appId-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:appId ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:appId"
  },
  {
    "shape": "cogo:ExampleShape#appId-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:appId ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.appId must be xsd:string"
  },
  {
    "shape": "cogo:ExampleShape#approvedAt-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:approvedAt ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:approvedAt"
  },
  {
    "shape": "cogo:ExampleShape#approvedAt-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:approvedAt ?v .\n  FILTER(DATATYPE(?v) != xsd:dateTime)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.approvedAt must be xsd:dateTime"
  },
  {
    "shape": "cogo:ExampleShape#blockJson-min-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Example .\n  FILTER NOT EXISTS { ?focus cogo:blockJson ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example is missing cogo:blockJson (minCount=1)"
  },
  {
    "shape": "cogo:ExampleShape#blockJson-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:blockJson ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:blockJson"
  },
  {
    "shape": "cogo:ExampleShape#blockJson-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:blockJson ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.blockJson must be xsd:string"
  },
  {
    "shape": "cogo:ExampleShape#blockType-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:blockType ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:blockType"
  },
  {
    "shape": "cogo:ExampleShape#blockType-class",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:blockType ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.blockType must be a cogo:SemanticType"
  },
  {
    "shape": "cogo:ExampleShape#name-min-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Example .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:ExampleShape#name-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:name"
  },
  {
    "shape": "cogo:ExampleShape#name-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.name must be xsd:string"
  },
  {
    "shape": "cogo:ExampleShape#pattern-min-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Example .\n  FILTER NOT EXISTS { ?focus cogo:pattern ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example is missing cogo:pattern (minCount=1)"
  },
  {
    "shape": "cogo:ExampleShape#pattern-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:pattern ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:pattern"
  },
  {
    "shape": "cogo:ExampleShape#pattern-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:pattern ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.pattern must be xsd:string"
  },
  {
    "shape": "cogo:ExampleShape#qualityGrade-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:qualityGrade ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:qualityGrade"
  },
  {
    "shape": "cogo:ExampleShape#qualityGrade-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:qualityGrade ?v .\n  FILTER(DATATYPE(?v) != xsd:integer)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.qualityGrade must be xsd:integer"
  },
  {
    "shape": "cogo:ExampleShape#score-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:score ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:score"
  },
  {
    "shape": "cogo:ExampleShape#score-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:score ?v .\n  FILTER(DATATYPE(?v) != xsd:integer)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.score must be xsd:integer"
  },
  {
    "shape": "cogo:ExampleShape#usesAction-class",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:usesAction ?v .\n  FILTER NOT EXISTS { ?v a cogo:Action }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.usesAction must be a cogo:Action"
  },
  {
    "shape": "cogo:ExampleShape#usesDataSymbol-class",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:usesDataSymbol ?v .\n  FILTER NOT EXISTS { ?v a cogo:DataSymbol }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.usesDataSymbol must be a cogo:DataSymbol"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#bindingSchema-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:bindingSchema ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:bindingSchema"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#dsCompatibility-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:dsCompatibility ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:dsCompatibility"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#dsCompatibility-class",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:dsCompatibility ?v .\n  FILTER NOT EXISTS { ?v a cogo:DsCompatibility }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.dsCompatibility must be a cogo:DsCompatibility"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#exampleTags-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:exampleTags ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.exampleTags must be xsd:string"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#narrativeSummary-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:narrativeSummary ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:narrativeSummary"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#narrativeSummary-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:narrativeSummary ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.narrativeSummary must be xsd:string"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#patternRef-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:patternRef ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:patternRef"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#patternRef-class",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:patternRef ?v .\n  FILTER NOT EXISTS { ?v a cogo:Pattern }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.patternRef must be a cogo:Pattern"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#semanticType-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:semanticType ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:semanticType"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#semanticType-class",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:semanticType ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.semanticType must be a cogo:SemanticType"
  },
  {
    "shape": "cogo:ExampleExtensionsShape#template-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:template ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:template"
  },
  {
    "shape": "cogo:NoLocalhostURIShape#template-max-count",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Example ; cogo:template ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example has more than 1 cogo:template"
  },
  {
    "shape": "cogo:NoLocalhostURIShape#template-datatype",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:template ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.template must be xsd:string"
  },
  {
    "shape": "cogo:NoLocalhostURIShape#template-pattern",
    "focusClass": "Example",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Example ; cogo:template ?v .\n  FILTER(!REGEX(STR(?v), \"^((?!https?://(localhost|127\\\\.0\\\\.0\\\\.1|0\\\\.0\\\\.0\\\\.0)).)*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Example.template must match /^((?!https?://(localhost|127\\.0\\.0\\.1|0\\.0\\.0\\.0)).)*$/"
  },
  {
    "shape": "cogo:FieldDefinitionShape#description-max-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition has more than 1 cogo:description"
  },
  {
    "shape": "cogo:FieldDefinitionShape#description-datatype",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition.description must be xsd:string"
  },
  {
    "shape": "cogo:FieldDefinitionShape#fieldType-min-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:FieldDefinition .\n  FILTER NOT EXISTS { ?focus cogo:fieldType ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition is missing cogo:fieldType (minCount=1)"
  },
  {
    "shape": "cogo:FieldDefinitionShape#fieldType-max-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:fieldType ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition has more than 1 cogo:fieldType"
  },
  {
    "shape": "cogo:FieldDefinitionShape#fieldType-datatype",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:fieldType ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition.fieldType must be xsd:string"
  },
  {
    "shape": "cogo:FieldDefinitionShape#fieldType-in",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:fieldType ?v .\n  FILTER(STR(?v) NOT IN (\"string\", \"number\", \"boolean\", \"object\", \"array\", \"uri\", \"date\", \"datetime\", \"money\", \"any\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition.fieldType must be one of [string, number, boolean, object, array, uri, date, datetime, money, any]"
  },
  {
    "shape": "cogo:FieldDefinitionShape#name-min-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:FieldDefinition .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:FieldDefinitionShape#name-max-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition has more than 1 cogo:name"
  },
  {
    "shape": "cogo:FieldDefinitionShape#name-datatype",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition.name must be xsd:string"
  },
  {
    "shape": "cogo:FieldDefinitionShape#name-pattern",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-zA-Z_][a-zA-Z0-9_]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition.name must match /^[a-zA-Z_][a-zA-Z0-9_]*$/"
  },
  {
    "shape": "cogo:FieldDefinitionShape#required-min-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:FieldDefinition .\n  FILTER NOT EXISTS { ?focus cogo:required ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition is missing cogo:required (minCount=1)"
  },
  {
    "shape": "cogo:FieldDefinitionShape#required-max-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:required ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition has more than 1 cogo:required"
  },
  {
    "shape": "cogo:FieldDefinitionShape#required-datatype",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:required ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition.required must be xsd:boolean"
  },
  {
    "shape": "cogo:FieldDefinitionShape#unit-max-count",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:unit ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition has more than 1 cogo:unit"
  },
  {
    "shape": "cogo:FieldDefinitionShape#unit-datatype",
    "focusClass": "FieldDefinition",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:FieldDefinition ; cogo:unit ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "FieldDefinition.unit must be xsd:string"
  },
  {
    "shape": "cogo:I18nShape#dateFormats-max-count",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:I18n ; cogo:dateFormats ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n has more than 1 cogo:dateFormats"
  },
  {
    "shape": "cogo:I18nShape#dateFormats-datatype",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:I18n ; cogo:dateFormats ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n.dateFormats must be xsd:string"
  },
  {
    "shape": "cogo:I18nShape#defaultLocale-min-count",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:I18n .\n  FILTER NOT EXISTS { ?focus cogo:defaultLocale ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n is missing cogo:defaultLocale (minCount=1)"
  },
  {
    "shape": "cogo:I18nShape#defaultLocale-max-count",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:I18n ; cogo:defaultLocale ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n has more than 1 cogo:defaultLocale"
  },
  {
    "shape": "cogo:I18nShape#defaultLocale-datatype",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:I18n ; cogo:defaultLocale ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n.defaultLocale must be xsd:string"
  },
  {
    "shape": "cogo:I18nShape#defaultLocale-pattern",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:I18n ; cogo:defaultLocale ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z]{2,3}(-[A-Za-z0-9]+)*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n.defaultLocale must match /^[a-z]{2,3}(-[A-Za-z0-9]+)*$/"
  },
  {
    "shape": "cogo:I18nShape#localeOverrides-datatype",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:I18n ; cogo:localeOverrides ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n.localeOverrides must be xsd:string"
  },
  {
    "shape": "cogo:I18nShape#numberFormats-max-count",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:I18n ; cogo:numberFormats ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n has more than 1 cogo:numberFormats"
  },
  {
    "shape": "cogo:I18nShape#numberFormats-datatype",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:I18n ; cogo:numberFormats ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n.numberFormats must be xsd:string"
  },
  {
    "shape": "cogo:I18nShape#supportedLocales-min-count",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:I18n .\n  FILTER NOT EXISTS { ?focus cogo:supportedLocales ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n is missing cogo:supportedLocales (minCount=1)"
  },
  {
    "shape": "cogo:I18nShape#supportedLocales-datatype",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:I18n ; cogo:supportedLocales ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n.supportedLocales must be xsd:string"
  },
  {
    "shape": "cogo:I18nShape#supportedLocales-pattern",
    "focusClass": "I18n",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:I18n ; cogo:supportedLocales ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z]{2,3}(-[A-Za-z0-9]+)*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "I18n.supportedLocales must match /^[a-z]{2,3}(-[A-Za-z0-9]+)*$/"
  },
  {
    "shape": "cogo:NarrativeShape#agentPromptGuide-max-count",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Narrative ; cogo:agentPromptGuide ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative has more than 1 cogo:agentPromptGuide"
  },
  {
    "shape": "cogo:NarrativeShape#agentPromptGuide-datatype",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Narrative ; cogo:agentPromptGuide ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative.agentPromptGuide must be xsd:string"
  },
  {
    "shape": "cogo:NarrativeShape#colorRoles-datatype",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Narrative ; cogo:colorRoles ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative.colorRoles must be xsd:string"
  },
  {
    "shape": "cogo:NarrativeShape#dosDonts-datatype",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Narrative ; cogo:dosDonts ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative.dosDonts must be xsd:string"
  },
  {
    "shape": "cogo:NarrativeShape#responsiveBehavior-max-count",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Narrative ; cogo:responsiveBehavior ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative has more than 1 cogo:responsiveBehavior"
  },
  {
    "shape": "cogo:NarrativeShape#responsiveBehavior-datatype",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Narrative ; cogo:responsiveBehavior ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative.responsiveBehavior must be xsd:string"
  },
  {
    "shape": "cogo:NarrativeShape#visualTheme-max-count",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Narrative ; cogo:visualTheme ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative has more than 1 cogo:visualTheme"
  },
  {
    "shape": "cogo:NarrativeShape#visualTheme-datatype",
    "focusClass": "Narrative",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Narrative ; cogo:visualTheme ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Narrative.visualTheme must be xsd:string"
  },
  {
    "shape": "cogo:ObservationShape#blockRef-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:blockRef ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:blockRef"
  },
  {
    "shape": "cogo:ObservationShape#confidence-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:confidence ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:confidence"
  },
  {
    "shape": "cogo:ObservationShape#confidence-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:confidence ?v .\n  FILTER(DATATYPE(?v) != xsd:decimal)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.confidence must be xsd:decimal"
  },
  {
    "shape": "cogo:ObservationShape#description-min-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Observation .\n  FILTER NOT EXISTS { ?focus cogo:description ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation is missing cogo:description (minCount=1)"
  },
  {
    "shape": "cogo:ObservationShape#description-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:description"
  },
  {
    "shape": "cogo:ObservationShape#description-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.description must be xsd:string"
  },
  {
    "shape": "cogo:ObservationShape#judgeModel-min-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Observation .\n  FILTER NOT EXISTS { ?focus cogo:judgeModel ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation is missing cogo:judgeModel (minCount=1)"
  },
  {
    "shape": "cogo:ObservationShape#judgeModel-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:judgeModel ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:judgeModel"
  },
  {
    "shape": "cogo:ObservationShape#judgeModel-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:judgeModel ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.judgeModel must be xsd:string"
  },
  {
    "shape": "cogo:ObservationShape#observedAt-min-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Observation .\n  FILTER NOT EXISTS { ?focus cogo:observedAt ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation is missing cogo:observedAt (minCount=1)"
  },
  {
    "shape": "cogo:ObservationShape#observedAt-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:observedAt ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:observedAt"
  },
  {
    "shape": "cogo:ObservationShape#observedAt-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:observedAt ?v .\n  FILTER(DATATYPE(?v) != xsd:dateTime)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.observedAt must be xsd:dateTime"
  },
  {
    "shape": "cogo:ObservationShape#pattern-min-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Observation .\n  FILTER NOT EXISTS { ?focus cogo:pattern ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation is missing cogo:pattern (minCount=1)"
  },
  {
    "shape": "cogo:ObservationShape#pattern-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:pattern ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:pattern"
  },
  {
    "shape": "cogo:ObservationShape#pattern-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:pattern ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.pattern must be xsd:string"
  },
  {
    "shape": "cogo:ObservationShape#proposedRule-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:proposedRule ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:proposedRule"
  },
  {
    "shape": "cogo:ObservationShape#proposedRule-class",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:proposedRule ?v .\n  FILTER NOT EXISTS { ?v a cogo:Rule }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.proposedRule must be a cogo:Rule"
  },
  {
    "shape": "cogo:ObservationShape#severity-min-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Observation .\n  FILTER NOT EXISTS { ?focus cogo:severity ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation is missing cogo:severity (minCount=1)"
  },
  {
    "shape": "cogo:ObservationShape#severity-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:severity ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:severity"
  },
  {
    "shape": "cogo:ObservationShape#severity-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:severity ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.severity must be xsd:string"
  },
  {
    "shape": "cogo:ObservationShape#severity-in",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:severity ?v .\n  FILTER(STR(?v) NOT IN (\"blocker\", \"major\", \"minor\", \"nit\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.severity must be one of [blocker, major, minor, nit]"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#candidateAction-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:candidateAction ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:candidateAction"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#candidateAction-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:candidateAction ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.candidateAction must be xsd:string"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#candidateAction-in",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:candidateAction ?v .\n  FILTER(STR(?v) NOT IN (\"rule-draft\", \"example-candidate\", \"recipe-extension\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.candidateAction must be one of [rule-draft, example-candidate, recipe-extension]"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#frequency-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:frequency ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:frequency"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#frequency-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:frequency ?v .\n  FILTER(DATATYPE(?v) != xsd:integer)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.frequency must be xsd:integer"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#obsSeverity-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:obsSeverity ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:obsSeverity"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#obsSeverity-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:obsSeverity ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.obsSeverity must be xsd:string"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#obsSeverity-in",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:obsSeverity ?v .\n  FILTER(STR(?v) NOT IN (\"warning\", \"error\", \"hint\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.obsSeverity must be one of [warning, error, hint]"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#timestamp-max-count",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Observation ; cogo:timestamp ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation has more than 1 cogo:timestamp"
  },
  {
    "shape": "cogo:ObservationExtensionsShape#timestamp-datatype",
    "focusClass": "Observation",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Observation ; cogo:timestamp ?v .\n  FILTER(DATATYPE(?v) != xsd:dateTime)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Observation.timestamp must be xsd:dateTime"
  },
  {
    "shape": "cogo:PageShape#hasSection-min-count",
    "focusClass": "Page",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Page .\n  FILTER NOT EXISTS { ?focus cogo:hasSection ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Page is missing cogo:hasSection (minCount=1)"
  },
  {
    "shape": "cogo:PageShape#hasSection-class",
    "focusClass": "Page",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Page ; cogo:hasSection ?v .\n  FILTER NOT EXISTS { ?v a cogo:Section }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Page.hasSection must be a cogo:Section"
  },
  {
    "shape": "cogo:PageShape#route-max-count",
    "focusClass": "Page",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Page ; cogo:route ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Page has more than 1 cogo:route"
  },
  {
    "shape": "cogo:PageShape#route-datatype",
    "focusClass": "Page",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Page ; cogo:route ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Page.route must be xsd:string"
  },
  {
    "shape": "cogo:PatternShape#domainSemantics-max-count",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Pattern ; cogo:domainSemantics ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern has more than 1 cogo:domainSemantics"
  },
  {
    "shape": "cogo:PatternShape#domainSemantics-datatype",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:domainSemantics ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.domainSemantics must be xsd:string"
  },
  {
    "shape": "cogo:PatternShape#patternId-min-count",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Pattern .\n  FILTER NOT EXISTS { ?focus cogo:patternId ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern is missing cogo:patternId (minCount=1)"
  },
  {
    "shape": "cogo:PatternShape#patternId-max-count",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Pattern ; cogo:patternId ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern has more than 1 cogo:patternId"
  },
  {
    "shape": "cogo:PatternShape#patternId-datatype",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:patternId ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.patternId must be xsd:string"
  },
  {
    "shape": "cogo:PatternShape#patternId-pattern",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:patternId ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.patternId must match /^[a-z][a-z0-9-]*$/"
  },
  {
    "shape": "cogo:PatternShape#requiredBindings-datatype",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:requiredBindings ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.requiredBindings must be xsd:string"
  },
  {
    "shape": "cogo:PatternShape#requiredChildren-datatype",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:requiredChildren ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.requiredChildren must be xsd:string"
  },
  {
    "shape": "cogo:PatternShape#requiredEvents-datatype",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:requiredEvents ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.requiredEvents must be xsd:string"
  },
  {
    "shape": "cogo:PatternShape#semanticRoot-min-count",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Pattern .\n  FILTER NOT EXISTS { ?focus cogo:semanticRoot ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern is missing cogo:semanticRoot (minCount=1)"
  },
  {
    "shape": "cogo:PatternShape#semanticRoot-max-count",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Pattern ; cogo:semanticRoot ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern has more than 1 cogo:semanticRoot"
  },
  {
    "shape": "cogo:PatternShape#semanticRoot-class",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:semanticRoot ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.semanticRoot must be a cogo:SemanticType"
  },
  {
    "shape": "cogo:PatternArchetypeEdgeShape#archetype-max-count",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Pattern ; cogo:archetype ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern has more than 1 cogo:archetype"
  },
  {
    "shape": "cogo:PatternArchetypeEdgeShape#archetype-datatype",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:archetype ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.archetype must be xsd:string"
  },
  {
    "shape": "cogo:PatternArchetypeEdgeShape#archetype-in",
    "focusClass": "Pattern",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Pattern ; cogo:archetype ?v .\n  FILTER(STR(?v) NOT IN (\"auth-login\", \"auth-signup\", \"list-view\", \"detail-view\", \"form-submit\", \"dashboard\", \"settings\", \"checkout\", \"onboarding\", \"generic\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Pattern.archetype must be one of [auth-login, auth-signup, list-view, detail-view, form-submit, dashboard, settings, checkout, onboarding, generic]"
  },
  {
    "shape": "cogo:PlatformSupportShape#flutter-min-count",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:PlatformSupport .\n  FILTER NOT EXISTS { ?focus cogo:flutter ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport is missing cogo:flutter (minCount=1)"
  },
  {
    "shape": "cogo:PlatformSupportShape#flutter-max-count",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:PlatformSupport ; cogo:flutter ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport has more than 1 cogo:flutter"
  },
  {
    "shape": "cogo:PlatformSupportShape#flutter-datatype",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:PlatformSupport ; cogo:flutter ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport.flutter must be xsd:boolean"
  },
  {
    "shape": "cogo:PlatformSupportShape#reactNative-min-count",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:PlatformSupport .\n  FILTER NOT EXISTS { ?focus cogo:reactNative ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport is missing cogo:reactNative (minCount=1)"
  },
  {
    "shape": "cogo:PlatformSupportShape#reactNative-max-count",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:PlatformSupport ; cogo:reactNative ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport has more than 1 cogo:reactNative"
  },
  {
    "shape": "cogo:PlatformSupportShape#reactNative-datatype",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:PlatformSupport ; cogo:reactNative ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport.reactNative must be xsd:boolean"
  },
  {
    "shape": "cogo:PlatformSupportShape#web-min-count",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:PlatformSupport .\n  FILTER NOT EXISTS { ?focus cogo:web ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport is missing cogo:web (minCount=1)"
  },
  {
    "shape": "cogo:PlatformSupportShape#web-max-count",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:PlatformSupport ; cogo:web ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport has more than 1 cogo:web"
  },
  {
    "shape": "cogo:PlatformSupportShape#web-datatype",
    "focusClass": "PlatformSupport",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:PlatformSupport ; cogo:web ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "PlatformSupport.web must be xsd:boolean"
  },
  {
    "shape": "cogo:ReferoStyleShape#colors-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:colors ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:colors"
  },
  {
    "shape": "cogo:ReferoStyleShape#colors-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:colors ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.colors must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#components-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:components ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:components"
  },
  {
    "shape": "cogo:ReferoStyleShape#components-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:components ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.components must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#industry-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:industry ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:industry"
  },
  {
    "shape": "cogo:ReferoStyleShape#industry-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:industry ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.industry must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#name-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:name"
  },
  {
    "shape": "cogo:ReferoStyleShape#name-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.name must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#name-pattern",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.name must match /^[a-z][a-z0-9-]*$/"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoTitle-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:referoTitle ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:referoTitle"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoTitle-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:referoTitle ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.referoTitle must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoUrl-min-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:ReferoStyle .\n  FILTER NOT EXISTS { ?focus cogo:referoUrl ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle is missing cogo:referoUrl (minCount=1)"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoUrl-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:referoUrl ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:referoUrl"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoUrl-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:referoUrl ?v .\n  FILTER(DATATYPE(?v) != xsd:anyURI)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.referoUrl must be xsd:anyURI"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoUuid-min-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:ReferoStyle .\n  FILTER NOT EXISTS { ?focus cogo:referoUuid ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle is missing cogo:referoUuid (minCount=1)"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoUuid-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:referoUuid ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:referoUuid"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoUuid-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:referoUuid ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.referoUuid must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#referoUuid-pattern",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:referoUuid ?v .\n  FILTER(!REGEX(STR(?v), \"^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.referoUuid must match /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/"
  },
  {
    "shape": "cogo:ReferoStyleShape#spacing-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:spacing ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:spacing"
  },
  {
    "shape": "cogo:ReferoStyleShape#spacing-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:spacing ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.spacing must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#styleTheme-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:styleTheme ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:styleTheme"
  },
  {
    "shape": "cogo:ReferoStyleShape#styleTheme-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:styleTheme ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.styleTheme must be xsd:string"
  },
  {
    "shape": "cogo:ReferoStyleShape#styleTheme-in",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:styleTheme ?v .\n  FILTER(STR(?v) NOT IN (\"light\", \"dark\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.styleTheme must be one of [light, dark]"
  },
  {
    "shape": "cogo:ReferoStyleShape#typeScale-max-count",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:typeScale ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle has more than 1 cogo:typeScale"
  },
  {
    "shape": "cogo:ReferoStyleShape#typeScale-datatype",
    "focusClass": "ReferoStyle",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:ReferoStyle ; cogo:typeScale ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "ReferoStyle.typeScale must be xsd:string"
  },
  {
    "shape": "cogo:RuleShape#appliesTo-min-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Rule .\n  FILTER NOT EXISTS { ?focus cogo:appliesTo ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule is missing cogo:appliesTo (minCount=1)"
  },
  {
    "shape": "cogo:RuleShape#canonicalSource-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:canonicalSource ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:canonicalSource"
  },
  {
    "shape": "cogo:RuleShape#canonicalSource-datatype",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:canonicalSource ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.canonicalSource must be xsd:string"
  },
  {
    "shape": "cogo:RuleShape#category-min-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Rule .\n  FILTER NOT EXISTS { ?focus cogo:category ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule is missing cogo:category (minCount=1)"
  },
  {
    "shape": "cogo:RuleShape#category-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:category ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:category"
  },
  {
    "shape": "cogo:RuleShape#category-datatype",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:category ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.category must be xsd:string"
  },
  {
    "shape": "cogo:RuleShape#category-in",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:category ?v .\n  FILTER(STR(?v) NOT IN (\"structural\", \"semantic-type\", \"design-system\", \"accessibility\", \"contract\", \"runtime\", \"actionflow\", \"data-binding\", \"security\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.category must be one of [structural, semantic-type, design-system, accessibility, contract, runtime, actionflow, data-binding, security]"
  },
  {
    "shape": "cogo:RuleShape#code-min-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Rule .\n  FILTER NOT EXISTS { ?focus cogo:code ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule is missing cogo:code (minCount=1)"
  },
  {
    "shape": "cogo:RuleShape#code-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:code ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:code"
  },
  {
    "shape": "cogo:RuleShape#code-datatype",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:code ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.code must be xsd:string"
  },
  {
    "shape": "cogo:RuleShape#code-pattern",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:code ?v .\n  FILTER(!REGEX(STR(?v), \"^[A-Za-z][A-Za-z0-9._-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.code must match /^[A-Za-z][A-Za-z0-9._-]*$/"
  },
  {
    "shape": "cogo:RuleShape#message-min-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Rule .\n  FILTER NOT EXISTS { ?focus cogo:message ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule is missing cogo:message (minCount=1)"
  },
  {
    "shape": "cogo:RuleShape#message-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:message ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:message"
  },
  {
    "shape": "cogo:RuleShape#message-datatype",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:message ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.message must be xsd:string"
  },
  {
    "shape": "cogo:RuleShape#severity-min-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Rule .\n  FILTER NOT EXISTS { ?focus cogo:severity ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule is missing cogo:severity (minCount=1)"
  },
  {
    "shape": "cogo:RuleShape#severity-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:severity ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:severity"
  },
  {
    "shape": "cogo:RuleShape#severity-datatype",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:severity ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.severity must be xsd:string"
  },
  {
    "shape": "cogo:RuleShape#severity-in",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:severity ?v .\n  FILTER(STR(?v) NOT IN (\"error\", \"warning\", \"info\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.severity must be one of [error, warning, info]"
  },
  {
    "shape": "cogo:RuleShape#shape-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:shape ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:shape"
  },
  {
    "shape": "cogo:RuleShape#sparqlAsk-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:sparqlAsk ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:sparqlAsk"
  },
  {
    "shape": "cogo:RuleShape#sparqlAsk-datatype",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:sparqlAsk ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.sparqlAsk must be xsd:string"
  },
  {
    "shape": "cogo:RuleExtensionsShape#phase-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:phase ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:phase"
  },
  {
    "shape": "cogo:RuleExtensionsShape#phase-datatype",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:phase ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.phase must be xsd:string"
  },
  {
    "shape": "cogo:RuleExtensionsShape#phase-in",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:phase ?v .\n  FILTER(STR(?v) NOT IN (\"structural\", \"binding\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.phase must be one of [structural, binding]"
  },
  {
    "shape": "cogo:RuleExtensionsShape#shacl-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:shacl ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:shacl"
  },
  {
    "shape": "cogo:RulePhaseValidShape#phase-max-count",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Rule ; cogo:phase ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule has more than 1 cogo:phase"
  },
  {
    "shape": "cogo:RulePhaseValidShape#phase-in",
    "focusClass": "Rule",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Rule ; cogo:phase ?v .\n  FILTER(STR(?v) NOT IN (\"structural\", \"binding\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Rule.phase must be one of [structural, binding]"
  },
  {
    "shape": "cogo:SemanticTypeShape#allowedChildren-class",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:allowedChildren ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.allowedChildren must be a cogo:SemanticType"
  },
  {
    "shape": "cogo:SemanticTypeShape#category-min-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SemanticType .\n  FILTER NOT EXISTS { ?focus cogo:category ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType is missing cogo:category (minCount=1)"
  },
  {
    "shape": "cogo:SemanticTypeShape#category-max-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticType ; cogo:category ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType has more than 1 cogo:category"
  },
  {
    "shape": "cogo:SemanticTypeShape#category-datatype",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:category ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.category must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeShape#category-in",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:category ?v .\n  FILTER(STR(?v) NOT IN (\"layout\", \"content\", \"form\", \"feedback\", \"nav\", \"chart\", \"data\", \"action\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.category must be one of [layout, content, form, feedback, nav, chart, data, action]"
  },
  {
    "shape": "cogo:SemanticTypeShape#interaction-datatype",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:interaction ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.interaction must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeShape#isShadcnPreset-min-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SemanticType .\n  FILTER NOT EXISTS { ?focus cogo:isShadcnPreset ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType is missing cogo:isShadcnPreset (minCount=1)"
  },
  {
    "shape": "cogo:SemanticTypeShape#isShadcnPreset-max-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticType ; cogo:isShadcnPreset ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType has more than 1 cogo:isShadcnPreset"
  },
  {
    "shape": "cogo:SemanticTypeShape#isShadcnPreset-datatype",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:isShadcnPreset ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.isShadcnPreset must be xsd:boolean"
  },
  {
    "shape": "cogo:SemanticTypeShape#name-min-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SemanticType .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:SemanticTypeShape#name-max-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticType ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType has more than 1 cogo:name"
  },
  {
    "shape": "cogo:SemanticTypeShape#name-datatype",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.name must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeShape#name-pattern",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9]*(-[a-z0-9]+)*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.name must match /^[a-z][a-z0-9]*(-[a-z0-9]+)*$/"
  },
  {
    "shape": "cogo:SemanticTypeShape#parentSlot-max-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticType ; cogo:parentSlot ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType has more than 1 cogo:parentSlot"
  },
  {
    "shape": "cogo:SemanticTypeShape#parentSlot-class",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:parentSlot ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticType }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.parentSlot must be a cogo:SemanticType"
  },
  {
    "shape": "cogo:SemanticTypeShape#prop-datatype",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:prop ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.prop must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeShape#slot-datatype",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:slot ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.slot must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeShape#supportsEvents-class",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:supportsEvents ?v .\n  FILTER NOT EXISTS { ?v a cogo:Event }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.supportsEvents must be a cogo:Event"
  },
  {
    "shape": "cogo:SemanticTypeRecipeEdgeShape#recipe-max-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticType ; cogo:recipe ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType has more than 1 cogo:recipe"
  },
  {
    "shape": "cogo:SemanticTypeRecipeEdgeShape#recipe-class",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticType ; cogo:recipe ?v .\n  FILTER NOT EXISTS { ?v a cogo:SemanticTypeRecipe }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType.recipe must be a cogo:SemanticTypeRecipe"
  },
  {
    "shape": "cogo:RowColumnCountShape#name-min-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SemanticType .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:HeroSingleH1Shape#name-min-count",
    "focusClass": "SemanticType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SemanticType .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticType is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#availableSizes-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:availableSizes ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.availableSizes must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#availableVariants-min-count",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SemanticTypeRecipe .\n  FILTER NOT EXISTS { ?focus cogo:availableVariants ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe is missing cogo:availableVariants (minCount=1)"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#availableVariants-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:availableVariants ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.availableVariants must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#classNameAllowed-max-count",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:classNameAllowed ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe has more than 1 cogo:classNameAllowed"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#classNameAllowed-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:classNameAllowed ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.classNameAllowed must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#classNameForbidden-max-count",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:classNameForbidden ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe has more than 1 cogo:classNameForbidden"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#classNameForbidden-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:classNameForbidden ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.classNameForbidden must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#rendererHandles-max-count",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:rendererHandles ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe has more than 1 cogo:rendererHandles"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#rendererHandles-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:rendererHandles ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.rendererHandles must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#slotsOptional-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:slotsOptional ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.slotsOptional must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#slotsRequired-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:slotsRequired ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.slotsRequired must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeShape#stateMatrix-datatype",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SemanticTypeRecipe ; cogo:stateMatrix ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe.stateMatrix must be xsd:string"
  },
  {
    "shape": "cogo:SemanticTypeRecipeConformanceShape#availableVariants-min-count",
    "focusClass": "SemanticTypeRecipe",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SemanticTypeRecipe .\n  FILTER NOT EXISTS { ?focus cogo:availableVariants ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SemanticTypeRecipe is missing cogo:availableVariants (minCount=1)"
  },
  {
    "shape": "cogo:SymbolBindingShape#appId-min-count",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SymbolBinding .\n  FILTER NOT EXISTS { ?focus cogo:appId ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding is missing cogo:appId (minCount=1)"
  },
  {
    "shape": "cogo:SymbolBindingShape#appId-max-count",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SymbolBinding ; cogo:appId ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding has more than 1 cogo:appId"
  },
  {
    "shape": "cogo:SymbolBindingShape#appId-datatype",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SymbolBinding ; cogo:appId ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding.appId must be xsd:string"
  },
  {
    "shape": "cogo:SymbolBindingShape#statePath-min-count",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SymbolBinding .\n  FILTER NOT EXISTS { ?focus cogo:statePath ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding is missing cogo:statePath (minCount=1)"
  },
  {
    "shape": "cogo:SymbolBindingShape#statePath-max-count",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SymbolBinding ; cogo:statePath ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding has more than 1 cogo:statePath"
  },
  {
    "shape": "cogo:SymbolBindingShape#statePath-datatype",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SymbolBinding ; cogo:statePath ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding.statePath must be xsd:string"
  },
  {
    "shape": "cogo:SymbolBindingShape#statePath-pattern",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SymbolBinding ; cogo:statePath ?v .\n  FILTER(!REGEX(STR(?v), \"^#(appData|pageData|_results|loginUser|uiState)(\\\\.|\\\\[|$).*\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding.statePath must match /^#(appData|pageData|_results|loginUser|uiState)(\\.|\\[|$).*/"
  },
  {
    "shape": "cogo:SymbolBindingShape#symbol-min-count",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:SymbolBinding .\n  FILTER NOT EXISTS { ?focus cogo:symbol ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding is missing cogo:symbol (minCount=1)"
  },
  {
    "shape": "cogo:SymbolBindingShape#symbol-max-count",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:SymbolBinding ; cogo:symbol ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding has more than 1 cogo:symbol"
  },
  {
    "shape": "cogo:SymbolBindingShape#symbol-class",
    "focusClass": "SymbolBinding",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:SymbolBinding ; cogo:symbol ?v .\n  FILTER NOT EXISTS { ?v a cogo:DataSymbol }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "SymbolBinding.symbol must be a cogo:DataSymbol"
  },
  {
    "shape": "cogo:TemplateShape#appId-min-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Template .\n  FILTER NOT EXISTS { ?focus cogo:appId ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template is missing cogo:appId (minCount=1)"
  },
  {
    "shape": "cogo:TemplateShape#appId-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:appId ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:appId"
  },
  {
    "shape": "cogo:TemplateShape#appId-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:appId ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.appId must be xsd:string"
  },
  {
    "shape": "cogo:TemplateShape#blocksCount-min-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Template .\n  FILTER NOT EXISTS { ?focus cogo:blocksCount ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template is missing cogo:blocksCount (minCount=1)"
  },
  {
    "shape": "cogo:TemplateShape#blocksCount-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:blocksCount ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:blocksCount"
  },
  {
    "shape": "cogo:TemplateShape#blocksCount-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:blocksCount ?v .\n  FILTER(DATATYPE(?v) != xsd:integer)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.blocksCount must be xsd:integer"
  },
  {
    "shape": "cogo:TemplateShape#category-min-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Template .\n  FILTER NOT EXISTS { ?focus cogo:category ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template is missing cogo:category (minCount=1)"
  },
  {
    "shape": "cogo:TemplateShape#category-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:category ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:category"
  },
  {
    "shape": "cogo:TemplateShape#category-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:category ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.category must be xsd:string"
  },
  {
    "shape": "cogo:TemplateShape#category-in",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:category ?v .\n  FILTER(STR(?v) NOT IN (\"ecommerce\", \"saas\", \"content\", \"productivity\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.category must be one of [ecommerce, saas, content, productivity]"
  },
  {
    "shape": "cogo:TemplateShape#description-min-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Template .\n  FILTER NOT EXISTS { ?focus cogo:description ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template is missing cogo:description (minCount=1)"
  },
  {
    "shape": "cogo:TemplateShape#description-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:description"
  },
  {
    "shape": "cogo:TemplateShape#description-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.description must be xsd:string"
  },
  {
    "shape": "cogo:TemplateShape#keyword-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:keyword ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.keyword must be xsd:string"
  },
  {
    "shape": "cogo:TemplateShape#name-min-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Template .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:TemplateShape#name-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:name"
  },
  {
    "shape": "cogo:TemplateShape#name-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.name must be xsd:string"
  },
  {
    "shape": "cogo:TemplateShape#route-min-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Template .\n  FILTER NOT EXISTS { ?focus cogo:route ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template is missing cogo:route (minCount=1)"
  },
  {
    "shape": "cogo:TemplateShape#route-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:route ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:route"
  },
  {
    "shape": "cogo:TemplateShape#route-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:route ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.route must be xsd:string"
  },
  {
    "shape": "cogo:TemplateShape#themeGradient-min-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Template .\n  FILTER NOT EXISTS { ?focus cogo:themeGradient ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template is missing cogo:themeGradient (minCount=1)"
  },
  {
    "shape": "cogo:TemplateShape#themeGradient-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:themeGradient ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:themeGradient"
  },
  {
    "shape": "cogo:TemplateShape#themeGradient-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:themeGradient ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.themeGradient must be xsd:string"
  },
  {
    "shape": "cogo:TemplateShape#thumbnail-max-count",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Template ; cogo:thumbnail ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template has more than 1 cogo:thumbnail"
  },
  {
    "shape": "cogo:TemplateShape#thumbnail-datatype",
    "focusClass": "Template",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Template ; cogo:thumbnail ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Template.thumbnail must be xsd:string"
  },
  {
    "shape": "cogo:ThemeShape#atomDefaultsRef-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:atomDefaultsRef ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:atomDefaultsRef"
  },
  {
    "shape": "cogo:ThemeShape#atomDefaultsRef-class",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:atomDefaultsRef ?v .\n  FILTER NOT EXISTS { ?v a cogo:Pattern }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.atomDefaultsRef must be a cogo:Pattern"
  },
  {
    "shape": "cogo:ThemeShape#i18nRef-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:i18nRef ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:i18nRef"
  },
  {
    "shape": "cogo:ThemeShape#i18nRef-class",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:i18nRef ?v .\n  FILTER NOT EXISTS { ?v a cogo:I18n }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.i18nRef must be a cogo:I18n"
  },
  {
    "shape": "cogo:ThemeShape#metadataDescription-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:metadataDescription ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:metadataDescription"
  },
  {
    "shape": "cogo:ThemeShape#metadataDescription-datatype",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:metadataDescription ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.metadataDescription must be xsd:string"
  },
  {
    "shape": "cogo:ThemeShape#metadataName-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:metadataName ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:metadataName"
  },
  {
    "shape": "cogo:ThemeShape#metadataName-datatype",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:metadataName ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.metadataName must be xsd:string"
  },
  {
    "shape": "cogo:ThemeShape#narrativeRef-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:narrativeRef ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:narrativeRef"
  },
  {
    "shape": "cogo:ThemeShape#narrativeRef-class",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:narrativeRef ?v .\n  FILTER NOT EXISTS { ?v a cogo:Narrative }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.narrativeRef must be a cogo:Narrative"
  },
  {
    "shape": "cogo:ThemeShape#themeId-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:themeId ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:themeId"
  },
  {
    "shape": "cogo:ThemeShape#themeId-datatype",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:themeId ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.themeId must be xsd:string"
  },
  {
    "shape": "cogo:ThemeShape#themeVersion-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:themeVersion ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:themeVersion"
  },
  {
    "shape": "cogo:ThemeShape#themeVersion-datatype",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:themeVersion ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.themeVersion must be xsd:string"
  },
  {
    "shape": "cogo:ThemeShape#tokensRef-max-count",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Theme ; cogo:tokensRef ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme has more than 1 cogo:tokensRef"
  },
  {
    "shape": "cogo:ThemeShape#tokensRef-class",
    "focusClass": "Theme",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Theme ; cogo:tokensRef ?v .\n  FILTER NOT EXISTS { ?v a cogo:Tokens }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Theme.tokensRef must be a cogo:Tokens"
  },
  {
    "shape": "cogo:TokenShape#description-max-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Token ; cogo:description ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token has more than 1 cogo:description"
  },
  {
    "shape": "cogo:TokenShape#description-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:description ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.description must be xsd:string"
  },
  {
    "shape": "cogo:TokenShape#hslDark-max-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Token ; cogo:hslDark ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token has more than 1 cogo:hslDark"
  },
  {
    "shape": "cogo:TokenShape#hslDark-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:hslDark ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.hslDark must be xsd:string"
  },
  {
    "shape": "cogo:TokenShape#hslLight-max-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Token ; cogo:hslLight ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token has more than 1 cogo:hslLight"
  },
  {
    "shape": "cogo:TokenShape#hslLight-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:hslLight ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.hslLight must be xsd:string"
  },
  {
    "shape": "cogo:TokenShape#lineHeight-max-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Token ; cogo:lineHeight ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token has more than 1 cogo:lineHeight"
  },
  {
    "shape": "cogo:TokenShape#lineHeight-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:lineHeight ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.lineHeight must be xsd:string"
  },
  {
    "shape": "cogo:TokenShape#name-min-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Token .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:TokenShape#name-max-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Token ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token has more than 1 cogo:name"
  },
  {
    "shape": "cogo:TokenShape#name-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.name must be xsd:string"
  },
  {
    "shape": "cogo:TokenShape#name-pattern",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.name must match /^[a-z][a-z0-9-]*$/"
  },
  {
    "shape": "cogo:TokenShape#tailwindClass-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:tailwindClass ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.tailwindClass must be xsd:string"
  },
  {
    "shape": "cogo:TokenShape#tokenType-min-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:Token .\n  FILTER NOT EXISTS { ?focus cogo:tokenType ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token is missing cogo:tokenType (minCount=1)"
  },
  {
    "shape": "cogo:TokenShape#tokenType-max-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Token ; cogo:tokenType ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token has more than 1 cogo:tokenType"
  },
  {
    "shape": "cogo:TokenShape#tokenType-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:tokenType ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.tokenType must be xsd:string"
  },
  {
    "shape": "cogo:TokenShape#tokenType-in",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:tokenType ?v .\n  FILTER(STR(?v) NOT IN (\"color\", \"typography\", \"radius\", \"shadow\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.tokenType must be one of [color, typography, radius, shadow]"
  },
  {
    "shape": "cogo:TokenShape#value-max-count",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:Token ; cogo:value ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token has more than 1 cogo:value"
  },
  {
    "shape": "cogo:TokenShape#value-datatype",
    "focusClass": "Token",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:Token ; cogo:value ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "Token.value must be xsd:string"
  },
  {
    "shape": "cogo:UiElementTypeShape#name-min-count",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:UiElementType .\n  FILTER NOT EXISTS { ?focus cogo:name ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType is missing cogo:name (minCount=1)"
  },
  {
    "shape": "cogo:UiElementTypeShape#name-max-count",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:UiElementType ; cogo:name ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType has more than 1 cogo:name"
  },
  {
    "shape": "cogo:UiElementTypeShape#name-datatype",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:UiElementType ; cogo:name ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType.name must be xsd:string"
  },
  {
    "shape": "cogo:UiElementTypeShape#name-pattern",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:UiElementType ; cogo:name ?v .\n  FILTER(!REGEX(STR(?v), \"^[a-z][a-z0-9_-]*$\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType.name must match /^[a-z][a-z0-9_-]*$/"
  },
  {
    "shape": "cogo:UiElementTypeShape#uiCategory-min-count",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:UiElementType .\n  FILTER NOT EXISTS { ?focus cogo:uiCategory ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType is missing cogo:uiCategory (minCount=1)"
  },
  {
    "shape": "cogo:UiElementTypeShape#uiCategory-max-count",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:UiElementType ; cogo:uiCategory ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType has more than 1 cogo:uiCategory"
  },
  {
    "shape": "cogo:UiElementTypeShape#uiCategory-datatype",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:UiElementType ; cogo:uiCategory ?v .\n  FILTER(DATATYPE(?v) != xsd:string)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType.uiCategory must be xsd:string"
  },
  {
    "shape": "cogo:UiElementTypeShape#uiCategory-in",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:UiElementType ; cogo:uiCategory ?v .\n  FILTER(STR(?v) NOT IN (\"smart\", \"layout\", \"form\", \"feedback\", \"navigation\", \"commerce-generic\", \"commerce-front-office\", \"collection\", \"basic\", \"interactive\", \"input\", \"data\", \"action\", \"table\", \"overlay\", \"display\", \"text\", \"media\", \"typography\", \"composition\", \"integration\"))\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType.uiCategory must be one of [smart, layout, form, feedback, navigation, commerce-generic, commerce-front-office, collection, basic, interactive, input, data, action, table, overlay, display, text, media, typography, composition, integration]"
  },
  {
    "shape": "cogo:UiElementTypeShape#uiMayContainChildren-min-count",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus WHERE {\n  ?focus a cogo:UiElementType .\n  FILTER NOT EXISTS { ?focus cogo:uiMayContainChildren ?_ . }\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType is missing cogo:uiMayContainChildren (minCount=1)"
  },
  {
    "shape": "cogo:UiElementTypeShape#uiMayContainChildren-max-count",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus (COUNT(?v) AS ?count) WHERE {\n  ?focus a cogo:UiElementType ; cogo:uiMayContainChildren ?v .\n}\nGROUP BY ?focus\nHAVING (?count > 1)\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType has more than 1 cogo:uiMayContainChildren"
  },
  {
    "shape": "cogo:UiElementTypeShape#uiMayContainChildren-datatype",
    "focusClass": "UiElementType",
    "sparql": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX cogo: <https://cogo.xyz/ns/v1#>\nSELECT ?focus ?v WHERE {\n  ?focus a cogo:UiElementType ; cogo:uiMayContainChildren ?v .\n  FILTER(DATATYPE(?v) != xsd:boolean)\n}\nLIMIT 20",
    "ask": false,
    "severity": "violation",
    "message": "UiElementType.uiMayContainChildren must be xsd:boolean"
  }
] as const

export const RULES_COUNT = 463
export const RULES_SUMMARY = "agentPromptGuide-datatype: 1, allowedChildren-class: 1, appId-datatype: 3, approvedAt-datatype: 1, archetype-datatype: 2, archetype-in: 2, atomDefaultsRef-class: 1, authModes-datatype: 1, authModes-in: 1, availableSizes-datatype: 1, availableVariants-datatype: 1, binding-class: 1, blockJson-datatype: 1, blocksCount-datatype: 1, blockType-class: 1, candidateAction-datatype: 1, candidateAction-in: 1, canonicalField-class: 1, canonicalSource-datatype: 1, category-datatype: 5, category-in: 5, classNameAllowed-datatype: 1, classNameForbidden-datatype: 1, code-datatype: 1, code-pattern: 1, colorRoles-datatype: 1, colors-datatype: 1, commonAction-class: 1, commonEvent-class: 1, components-datatype: 1, confidence-datatype: 1, configSchema-class: 1, dateFormats-datatype: 1, defaultComponent-class: 1, defaultLocale-datatype: 1, defaultLocale-pattern: 1, defaultTimeout-datatype: 1, deprecated-datatype: 1, description-datatype: 8, designSystemId-datatype: 1, designSystemId-pattern: 1, domain-datatype: 1, domain-in: 1, domainSemantics-datatype: 1, dosDonts-datatype: 1, dsCompatibility-class: 1, effects-class: 1, emitsEvents-class: 2, emittedByAction-class: 1, emittedByComponent-class: 1, emittedByDatasource-class: 1, exampleTags-datatype: 1, extends-class: 1, extendsSystem-class: 1, fieldType-datatype: 1, fieldType-in: 1, flutter-datatype: 1, frequency-datatype: 1, hasSection-class: 1, hslDark-datatype: 1, hslLight-datatype: 1, i18n-class: 1, i18nRef-class: 1, implementation-datatype: 1, implementation-pattern: 1, industry-datatype: 1, interaction-datatype: 1, isShadcnPreset-datatype: 1, judgeModel-datatype: 1, keyword-datatype: 1, level-datatype: 1, level-in: 1, lifecycleRules-datatype: 1, lifecycleRules-in: 1, lineHeight-datatype: 1, localeOverrides-datatype: 1, makesNetworkCalls-datatype: 1, max-count: 153, message-datatype: 1, metadataDescription-datatype: 1, metadataName-datatype: 1, min-count: 75, minFontScale-datatype: 1, minFontScale-in: 1, name-datatype: 14, name-pattern: 12, narrative-class: 1, narrativeRef-class: 1, narrativeSummary-datatype: 1, navigates-datatype: 1, numberFormats-datatype: 1, observedAt-datatype: 1, obsSeverity-datatype: 1, obsSeverity-in: 1, operationTypes-datatype: 1, operationTypes-in: 1, palette-datatype: 1, paramsSchema-class: 1, parentSlot-class: 1, pattern-datatype: 2, patternId-datatype: 1, patternId-pattern: 1, patternRef-class: 1, payloadSchema-class: 1, phase-datatype: 1, phase-in: 2, platform-datatype: 1, platform-in: 1, platforms-class: 2, presetClassMap-datatype: 1, promptKind-datatype: 1, promptKind-in: 1, prop-datatype: 1, proposedRule-class: 1, qualityGrade-datatype: 1, radius-datatype: 1, reactNative-datatype: 1, read-datatype: 1, recipe-class: 1, referoTitle-datatype: 1, referoUrl-datatype: 1, referoUuid-datatype: 1, referoUuid-pattern: 1, relatedActions-class: 1, rendererHandles-datatype: 1, replacedBy-class: 1, required-datatype: 1, requiredBindings-datatype: 1, requiredChildren-datatype: 1, requiredEvents-datatype: 1, requiredTokens-datatype: 1, requiresAuth-datatype: 1, requiresCapability-class: 2, responsiveBehavior-datatype: 1, resultShape-class: 1, reversible-datatype: 1, route-datatype: 2, score-datatype: 1, semanticRoot-class: 1, semanticType-class: 1, severity-datatype: 2, severity-in: 2, slot-datatype: 1, slotsOptional-datatype: 1, slotsRequired-datatype: 1, spacing-datatype: 1, sparqlAsk-datatype: 1, stateMatrix-datatype: 1, statePath-datatype: 1, statePath-pattern: 1, styleTheme-datatype: 1, styleTheme-in: 1, supportedLocales-datatype: 1, supportedLocales-pattern: 1, supportsEvents-class: 1, symbol-class: 1, tailwindClass-datatype: 1, template-datatype: 1, template-pattern: 1, themeGradient-datatype: 1, themeId-datatype: 1, themeVersion-datatype: 1, thumbnail-datatype: 1, tier-datatype: 1, tier-in: 1, timestamp-datatype: 1, tokens-class: 1, tokensRef-class: 1, tokenType-datatype: 1, tokenType-in: 1, tolerance-datatype: 1, transportProtocol-datatype: 1, transportProtocol-in: 1, typeScale-datatype: 1, typography-datatype: 1, uiCategory-datatype: 1, uiCategory-in: 1, uiMayContainChildren-datatype: 1, unit-datatype: 1, usesAction-class: 1, usesDataSymbol-class: 1, value-datatype: 1, visualTheme-datatype: 1, web-datatype: 1, wireCode-datatype: 1, write-datatype: 1"
